import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  wrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  img: {
    width: 200,
    margin: "24px 0 32px 0",
  },
  span: {
    color: "#465869",
    font: "600 16px/18px Manrope",
  },
}));

export default styles;
